// src/config/app.js
// Konfigurasi global aplikasi (frontend). Satu tempat untuk nilai yang
// kemungkinan berubah antar lingkungan / fase (testing vs produksi).
export const APP_CONFIG = {
  // Auto-logoff: durasi idle (tanpa aktivitas user) sebelum otomatis logout.
  // TESTING : 10 menit. PRODUKSI: disarankan 15–30 menit (mis. 30 * 60 * 1000).
  IDLE_LOGOUT_MS: 6000 * 60 * 1000,

  // Throttle: minimal jeda antar reset timer agar gerakan mouse beruntun
  // tidak memicu reset terus-menerus (hemat CPU). Cukup 1 detik.
  IDLE_ACTIVITY_THROTTLE_MS: 1000,
};
